import {Button} from 'primereact/button'
import {Column} from 'primereact/column'
import {DataTable} from 'primereact/datatable'
import {Dialog} from 'primereact/dialog'
import {forwardRef, useImperativeHandle, useState} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'

const ReminderTable = forwardRef((props, ref) => {
    const {translateCommons} = TranslateUtils()
    useImperativeHandle(ref, () => ({
        showForm: (day, dataList) => showForm(day, dataList),
    }))
    const [visible, setVisible] = useState(false)
    const [data, setData] = useState([])
    const [day, setDay] = useState('')

    const showForm = (day, dataList) => {
        blockOverflownScroll()
        setDay(day)
        setData(dataList ? dataList : [])
        setVisible(true)
    }

    const hideForm = () => {
        unblockOverflownScroll()
        setDay('')
        setData({})
        setVisible(false)
    }
    const columns = [
        {key: 'type', label: 'Type'},
        {key: 'description', label: 'Description'},
        {key: 'frequency', label: 'Frequency'},
        {key: 'instructions', label: 'Instructions'},
        {key: 'startDate', label: 'Start Date'},
        {key: 'endDate', label: 'End Date'},
    ]
    const dynamicColumns = columns.map((col, i) => {
        return (
            <Column
                key={col.key}
                header={translateCommons(col.label)}
                field={col.key}
                body={rowData => {
                    return (
                        <div
                            className=" overflow-dot overflow-text-2 capitalized"
                            style={{width: '100%'}}>
                            {col.key === 'frequency' ||
                            col.key === 'instructions'
                                ? translateCommons(rowData[col.key])
                                : rowData[col.key]}
                        </div>
                    )
                }}
            />
        )
    })

    const renderFooter = name => {
        return (
            <div>
                <Button
                    label={translateCommons('Close')}
                    icon="pi pi-times"
                    onClick={() => hideForm()}
                    className="p-button-text"
                />
            </div>
        )
    }

    return (
        <Dialog
            header={`${translateCommons('Summary')} ${
                day ? ` ${translateCommons('of')} ${day}` : ''
            }`}
            visible={visible}
            className="col-12 lg:col-8"
            footer={renderFooter('displayBasic')}
            onHide={() => hideForm()}
            blockScroll>
            {!!visible && (
                <DataTable
                    className="col-12"
                    value={data ? data : []}
                    rowHover={true}
                    emptyMessage={translateCommons('No reminders on this day')}
                    responsiveLayout="scroll">
                    {dynamicColumns}
                </DataTable>
            )}
        </Dialog>
    )
})

export default ReminderTable
